import axios from "axios";

export const getProjects = async (baseUrl, token) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  let getResponse = null;

  await axios
    .get(baseUrl + "/meeting/projects", config)
    .then((res) => {
      getResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        getResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return getResponse;
};